import React from 'react';
import { TrendingUpIcon, UsersIcon, DollarSignIcon, ActivityIcon } from 'lucide-react';
export function PartnerDashboard() {
  const customers = [{
    name: 'Acme Corp',
    users: 45,
    consumption: 12500,
    revenue: 3750,
    trend: 'up'
  }, {
    name: 'TechStart Inc',
    users: 28,
    consumption: 8200,
    revenue: 2460,
    trend: 'up'
  }, {
    name: 'Global Solutions',
    users: 62,
    consumption: 18900,
    revenue: 5670,
    trend: 'down'
  }];
  return <div className="max-w-7xl mx-auto" data-id="element-2188">
      {/* Stats Overview */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6" data-id="element-2189">
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2190">
          <div className="flex items-center gap-3 mb-2" data-id="element-2191">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-2192">
              <UsersIcon className="w-5 h-5 text-blue-600" data-id="element-2193" />
            </div>
            <div data-id="element-2194">
              <p className="text-sm text-gray-600" data-id="element-2195">Total Customers</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-2196">24</p>
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-green-600" data-id="element-2197">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2198" />
            <span data-id="element-2199">+12% this month</span>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2200">
          <div className="flex items-center gap-3 mb-2" data-id="element-2201">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-2202">
              <ActivityIcon className="w-5 h-5 text-purple-600" data-id="element-2203" />
            </div>
            <div data-id="element-2204">
              <p className="text-sm text-gray-600" data-id="element-2205">Total Users</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-2206">135</p>
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-green-600" data-id="element-2207">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2208" />
            <span data-id="element-2209">+8% this month</span>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2210">
          <div className="flex items-center gap-3 mb-2" data-id="element-2211">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-2212">
              <DollarSignIcon className="w-5 h-5 text-green-600" data-id="element-2213" />
            </div>
            <div data-id="element-2214">
              <p className="text-sm text-gray-600" data-id="element-2215">Monthly Revenue</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-2216">$11,880</p>
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-green-600" data-id="element-2217">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2218" />
            <span data-id="element-2219">+15% this month</span>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2220">
          <div className="flex items-center gap-3 mb-2" data-id="element-2221">
            <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center" data-id="element-2222">
              <ActivityIcon className="w-5 h-5 text-orange-600" data-id="element-2223" />
            </div>
            <div data-id="element-2224">
              <p className="text-sm text-gray-600" data-id="element-2225">Avg Consumption</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-2226">13.2K</p>
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-green-600" data-id="element-2227">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2228" />
            <span data-id="element-2229">+6% this month</span>
          </div>
        </div>
      </div>
      {/* Customer Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2230">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-2231">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-2232">
            Customer Usage & Revenue
          </h3>
        </div>
        <table className="w-full" data-id="element-2233">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-2234">
            <tr data-id="element-2235">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2236">
                Customer
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2237">
                Active Users
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2238">
                Consumption
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2239">
                Revenue
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-2240">
                Trend
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-2241">
            {customers.map((customer, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-2242">
                <td className="px-6 py-4" data-id="element-2243">
                  <p className="font-medium text-gray-900" data-id="element-2244">{customer.name}</p>
                </td>
                <td className="px-6 py-4" data-id="element-2245">
                  <p className="text-gray-900" data-id="element-2246">{customer.users}</p>
                </td>
                <td className="px-6 py-4" data-id="element-2247">
                  <p className="text-gray-900" data-id="element-2248">
                    {customer.consumption.toLocaleString()} credits
                  </p>
                </td>
                <td className="px-6 py-4" data-id="element-2249">
                  <p className="font-semibold text-gray-900" data-id="element-2250">
                    ${customer.revenue.toLocaleString()}
                  </p>
                </td>
                <td className="px-6 py-4" data-id="element-2251">
                  <div className={`flex items-center gap-1 ${customer.trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-2252">
                    <TrendingUpIcon className={`w-4 h-4 ${customer.trend === 'down' ? 'rotate-180' : ''}`} data-id="element-2253" />
                    <span className="text-sm font-medium" data-id="element-2254">
                      {customer.trend === 'up' ? '+12%' : '-5%'}
                    </span>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}